<template>
  <!-- <el-breadcrumb separator=">" class="breadcrumb-box">
    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
    <template v-for="(item, index) in breadList">
      <el-breadcrumb-item v-if="item.meta.title" :key="index" :to="item.path">{{
        item.meta.title
      }}</el-breadcrumb-item>
    </template>
  </el-breadcrumb> -->
  <el-config-provider :locale="locale">
    <!-- <div class="areaName">当前地区:{{ route.query.areaName }}</div> -->
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component
          :is="Component"
          :key="route.name"
          v-if="route.meta.keepAlive"
        />
      </keep-alive>
      <component
        :is="Component"
        :key="route.name"
        v-if="!route.meta.keepAlive"
      />
    </router-view>
    <!-- <router-view v-else></router-view> -->
  </el-config-provider>
</template>
<script>
import api from './api'
import { provide, onBeforeMount, ref, onMounted } from 'vue'
import utils from './assets/js/utils'
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import { useRoute, useRouter } from 'vue-router'
export default {
  name: 'App',
  components: { [ElConfigProvider.name]: ElConfigProvider },
  setup () {
    const route = useRoute()
    const router = useRouter()
    provide('$api', api)
    provide('$utils', utils)
    const breadList = ref([])
    onBeforeMount(() => {
    })
    router.afterEach(() => {
      breadList.value = route.matched
    })
    onMounted(() => {
      cookie.value = getCookie('mode')
      provide('$cookie', cookie.value)
      if(cookie.value == 2) {
        document.getElementsByTagName('body')[0].style.setProperty('--test16', '28px')
        document.getElementsByTagName('body')[0].style.setProperty('--test17', '28px')
        document.getElementsByTagName('body')[0].style.setProperty('--crumb16', '22px')
      } else {
        document.getElementsByTagName('body')[0].style.setProperty('--test16', '16px')
        document.getElementsByTagName('body')[0].style.setProperty('--test17', '17px')
        document.getElementsByTagName('body')[0].style.setProperty('--crumb16', '16px')
      }
    })

    const cookie = ref()

    const getCookie = (c_name) => {
      if (document.cookie.length > 0) {
        var  c_start = document.cookie.indexOf(c_name + '=')
        if (c_start != -1) {
          c_start = c_start + c_name.length + 1
          var c_end = document.cookie.indexOf(';' ,c_start)
          if (c_end == -1) c_end = document.cookie.length
          return unescape(document.cookie.substring(c_start, c_end))
        }
      }
      return ''
    }

    return {
      locale: zhCn,
      breadList,
      route,
      getCookie,
      cookie
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
body {
  margin: 0px auto;
  /* max-width: 1200px; */
  background: none;
}
html {
  background-color: #f7f7f7;
  font-family: 'Arial', 'PingFang SC', 'Helvetica Neue', Helvetica, sans-serif,
    system-ui, -apple-system, BlinkMacSystemFont;
}
</style>
<style lang="less">
.breadcrumb-box {
  margin: 0px auto;
  margin-top: 18px;
  max-width: 1200px;
  min-width: 980px;
}
.areaName{
  text-align: center;
  font-size: 20px;
  font-weight: 550;
}
.public_page{
  margin: 0px auto;
  max-width: 1200px;
  min-width: 980px;
  background-color: #fff;
  padding: 18px 40px 0px 40px;
  box-sizing: border-box;
}
</style>
